import { useMemo } from "react";
import { Pencil, Plus, Star, Trash2 } from "lucide-react";

import { Button } from "components/ui/Button";
import { DataTable } from "components/ui/DataTable";

import { useColumns } from "./hooks/useColumns";
import styles from "./LocationsTable.module.css";

export const LocationsTable = ({
  locations = [],
  isLoading = false,
  onEdit,
  onDelete,
  onSetDefault,
  onAdd,
}) => {
  const columns = useColumns();

  const activeCount = useMemo(
    () => locations.filter((l) => !l.disabled).length,
    [locations]
  );

  const rowActions = useMemo(
    () => [
      {
        label: "Edit",
        icon: Pencil,
        onClick: (row) => onEdit?.(row),
        primary: true,
        primaryOnly: true,
      },
      {
        label: "Set as default",
        icon: Star,
        onClick: (row) => onSetDefault?.(row),
        visibleWhen: (row) => !row.isDefault && !row.disabled,
      },
      {
        label: "Delete",
        icon: Trash2,
        onClick: (row) => onDelete?.(row),
        disabled: (row) => !row.disabled && activeCount <= 1,
        disabledReason: "A practice must always have at least one location",
      },
    ],
    [onEdit, onDelete, onSetDefault, activeCount]
  );

  return (
    <div>
      <div className={styles.header}>
        <h3 className={styles.title}>Locations</h3>
        <Button variant="text" onClick={onAdd} endIcon={Plus}>
          Add new location
        </Button>
      </div>
      <DataTable
        columns={columns}
        data={locations}
        getRowId={(row) => row.id}
        isLoading={isLoading}
        emptyTitle="No locations found"
        emptyText="Add a location for appointments to happen at."
        rowActions={rowActions}
      />
    </div>
  );
};
